/* Halloween 2026 – effekter. Laddas bara via snippets/os-halloween.liquid (släcks automatiskt efter 1 nov). */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = document;
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function html(el, pos, s) { el.insertAdjacentHTML(pos, s); }

  var SVG = {
    pumpkin: '<svg viewBox="0 0 24 24"><path fill="#2E7D32" d="M11 3.5c.6-1 1.8-1.6 3-1.4-.9.6-1.4 1.5-1.5 2.6l-1.5-.1z"/><ellipse cx="12" cy="13.5" rx="10" ry="8" fill="#FF7A1A"/><path fill="#5a1d00" d="M7 11l2.5-2 1.5 2.5zM17 11l-2.5-2-1.5 2.5zM6.5 15c2 2.4 9 2.4 11 0l-2 .6-1.2 1.2-1.3-1-1 1.1-1-1.1-1.3 1-1.2-1.2z"/></svg>',
    candy: '<svg viewBox="0 0 24 24"><path fill="#FFF3D6" d="M12 2 4 22h16z"/><path fill="#FFB000" d="M6.6 15.5h10.8L20 22H4z"/><path fill="#FF7A1A" d="M8.8 10h6.4l2.2 5.5H6.6z"/></svg>',
    bat: '<svg viewBox="0 0 64 32"><path fill="#111" d="M32 10c-1.2-2.4-2.4-3.2-2.4-3.2L28.8 9C24 6 16 2 0 6c6 1 10 4 11 9 3-2 7-2 9 1 2-2 5-2 7 1 1-2 3-3 5-3s4 1 5 3c2-3 5-3 7-1 2-3 6-3 9-1 1-5 5-8 11-9-16-4-24 0-28.8 3l-.8-2.2S33.2 7.6 32 10z"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path fill="#F4344C" d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.1 0 3.6 1.1 4.3 2.4.7-1.3 2.2-2.4 4.3-2.4 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z"/></svg>',
    ghost: '<svg viewBox="0 0 64 72"><path fill="#fff" d="M32 2C16 2 6 14 6 30v38l7-6 6 6 7-6 6 6 6-6 7 6 6-6 7 6V30C58 14 48 2 32 2z"/><ellipse cx="23" cy="28" rx="4.5" ry="6" fill="#111"/><ellipse cx="41" cy="28" rx="4.5" ry="6" fill="#111"/><ellipse cx="32" cy="42" rx="5" ry="6" fill="#111"/><ellipse cx="15" cy="38" rx="4" ry="2.4" fill="#FBE9F0"/><ellipse cx="49" cy="38" rx="4" ry="2.4" fill="#FBE9F0"/></svg>'
  };

  /* 1. Godisregn när något läggs i varukorgen */
  function burst(x, y) {
    if (RM) return;
    var kinds = ['candy', 'candy', 'pumpkin', 'bat', 'heart', 'candy'];
    var layer = D.createElement('div');
    layer.className = 'hw-burst';
    layer.setAttribute('aria-hidden', 'true');
    D.body.appendChild(layer);
    for (var i = 0; i < 16; i++) {
      var p = D.createElement('span');
      p.className = 'hw-burst__p';
      p.innerHTML = SVG[kinds[i % kinds.length]];
      var size = 16 + Math.random() * 14;
      p.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px';
      layer.appendChild(p);
      var ang = (-90 + (Math.random() * 140 - 70)) * Math.PI / 180;
      var dist = 90 + Math.random() * 140;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist;
      var rot = (Math.random() * 720 - 360);
      if (p.animate) {
        p.animate([
          { transform: 'translate(-50%,-50%) scale(.4) rotate(0deg)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(1) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: .55 },
          { transform: 'translate(calc(-50% + ' + dx * 1.15 + 'px),calc(-50% + ' + (dy + 220) + 'px)) scale(.9) rotate(' + rot + 'deg)', opacity: 0 }
        ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'forwards' });
      }
    }
    setTimeout(function () { layer.remove(); }, 1800);
  }
  var lastXY = null;
  D.addEventListener('pointerdown', function (e) { lastXY = [e.clientX, e.clientY]; }, true);
  D.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) {
      var b = f.querySelector('[type=submit],button[name=add]');
      var r = b ? b.getBoundingClientRect() : null;
      var xy = lastXY || (r ? [r.left + r.width / 2, r.top + r.height / 2] : [innerWidth / 2, innerHeight / 2]);
      burst(xy[0], xy[1]);
    }
  }, true);
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart], .add-to-cart, .product-card button[type="submit"], quick-add-button button');
    if (b && !b.closest('form[action*="/cart/add"]')) burst(e.clientX, e.clientY);
  }, true);

  /* 2. Hemlig kod som "krypteras" i bandet */
  function scramble() {
    var el = D.querySelector('#hw-band .hw__code--secret strong');
    if (!el || RM) return;
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789?#%';
    var on = false;
    var io = new IntersectionObserver(function (en) { on = en[0].isIntersecting; }, { threshold: .3 });
    io.observe(el);
    setInterval(function () {
      if (!on) return;
      var s = '';
      for (var i = 0; i < 8; i++) s += chars[Math.floor(Math.random() * chars.length)];
      el.textContent = s;
    }, 90);
  }

  /* 3. Dimma i heron */
  function fog() {
    var hero = D.querySelector('.os-hero');
    if (!hero || hero.querySelector('.hw-fog')) return;
    html(hero, 'beforeend', '<div class="hw-fog" aria-hidden="true"><span></span><span></span></div>');
  }

  /* 4. Spöket som tittar fram */
  function ghost() {
    if (ss('osHwGhost') === 'closed') return;
    var formId = window.osHwFormId || '';
    html(D.body, 'beforeend',
      '<div class="hw-ghost" role="complementary" aria-label="Halloween">' +
        '<button type="button" class="hw-ghost__close" aria-label="Stäng">×</button>' +
        '<button type="button" class="hw-ghost__btn" aria-label="Bus eller godis? Öppna Halloween-erbjudandet">' +
          '<span class="hw-ghost__bubble">Bus eller godis?</span>' +
          '<span class="hw-ghost__body">' + SVG.ghost + '</span>' +
        '</button>' +
      '</div>');
    var g = D.querySelector('.hw-ghost');
    setTimeout(function () { g.classList.add('is-in'); }, RM ? 0 : 6000);
    g.querySelector('.hw-ghost__close').addEventListener('click', function () {
      g.classList.remove('is-in'); ss('osHwGhost', 'closed');
      setTimeout(function () { g.remove(); }, 600);
    });
    g.querySelector('.hw-ghost__btn').addEventListener('click', function (e) {
      burst(e.clientX, e.clientY);
      function fallback() {
        var band = D.getElementById('hw-band');
        if (band) band.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        else location.href = '/#hw-band';
      }
      /* Bara ett synligt Klaviyo-fönster räknas – dolda/stängda formulär finns kvar i DOM:en */
      function formVisible() {
        var els = D.querySelectorAll('[role="dialog"][class*="kl-private-reset-css"]');
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.width > 0 && r.height > 0) return true;
        }
        return false;
      }
      if (formId) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
        setTimeout(function () {
          if (!formVisible()) fallback();
        }, 1500);
      } else {
        fallback();
      }
    });
  }

  /* 5. Pumpan i bandet: klick = godisregn */
  function pumpkinClick() {
    var p = D.querySelector('#hw-band .hw__pumpkin');
    if (!p) return;
    p.style.pointerEvents = 'auto';
    p.style.cursor = 'pointer';
    p.addEventListener('click', function (e) { burst(e.clientX, e.clientY); });
  }

  function init() { fog(); scramble(); ghost(); pumpkinClick(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
